module.exports = __webpack_public_path__ + "media/newstyle/images/icon-arrow-right-white-5fc3e78b96d0ce15ba7e629f5d083c74.svg";